/*
    Controller for displaying a dialog that allows creating a new development device group
    Usage: Radio.request(
        'global', 
        'show_create_development_devicegroup', 
        {{product}}
    );
    Arguments: 
        product: v5 "product" model (models/v5/product.js)
    
*/

import Radio from 'backbone.radio';
import CreateDevelopmentDevicegroupDialog from '@/views/dialogs/development_devicegroup_settings';

var globalCh = Radio.channel('global');
var apiCh = Radio.channel('api');

export default function show_create_device_group_dialog(product) {
    var devicegroups = apiCh.request('development_devicegroup');
    var create_development_devicegroup_dialog = new CreateDevelopmentDevicegroupDialog({
        collection: devicegroups,
        product: product,
        name_label: 'Device Group Name',
        description_label: 'Device Group Description',
        dialog_title: 'Create a Development Device Group',
        cancel_text: 'Cancel',
        submit_text: 'Create'
    });
    globalCh.request('showDialog', create_development_devicegroup_dialog);
}
